import { ROLE_DESCRIPTION } from 'src/features/auth/constants';
import { RoleType } from 'src/ts/interfaces';

/**
 * It takes a role and returns the description of that role
 * @param {RoleType} role - RoleType
 */
const roleToDisplay = (role: RoleType) => ROLE_DESCRIPTION[role] || 'Not found';
export default roleToDisplay;
